import { RootState } from '..';
import { TrackingDataState } from '../reducers/trackingData';

interface State extends RootState {
  trackingData: TrackingDataState;
}

export type TrackingData = State['trackingData'];

export const trackingDataSelector = ({ trackingData }: State): TrackingData => trackingData;
